export default __webpack_public_path__ + "static/media/introOPBgMb.c58a1b63.png";